<template>
  <div class="DataTable">
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
    >{{ vinogradGl1 }}</div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs3 pa-2>
          <v-autocomplete
            v-model="vineyard_select"
            :items="vineyard_items"
            item-text="name"
            item-value="id"
            :rules="[v => !!v || 'Obavezan podatak']"
            :label="vinogradGl"
            required
            persistent-hint
            return-object
          ></v-autocomplete>
        </v-flex>
        <!-- v-on:change="changeRoute" -->

        <v-flex xs3 pa-2>
          <v-autocomplete
            v-model="select"
            :items="wt_items"
            item-text="name"
            item-value="id"
            :rules="[v => !!v || 'Obavezan podatak']"
            label="Sorta"
            required
            persistent-hint
            return-object
          ></v-autocomplete>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-text-field v-model="velicina" label="Veličina" type="number"></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-autocomplete
            v-model="jm_select"
            :items="jm_items"
            item-text="mark"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 pa-2>
          <!-- <v-menu
            ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            :nudge-right="0"
            :return-value.sync="datum_zasada"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field slot="activator" v-model="datum_zasada" label="Zasadjen" readonly></v-text-field>
            <v-date-picker v-model="datum_zasada" no-title scrollable :max="maxDate">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.menu.save(datum_zasada)">OK</v-btn>
            </v-date-picker>
          </v-menu> -->
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="datum_zasada"
              label="Zasađen"
              readonly
                @blur="date_zasada = parseDate(datum_zasada)"
                required
                :rules="[v => !!v || 'Obavezan podatak']"
            ></v-text-field>
            <v-date-picker v-model="date_zasada" no-title @input="menu = false" :max="maxDate"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <!-- <v-menu
            ref="menu_iskopavanja"
            :close-on-content-click="false"
            v-model="menu_iskopavanja"
            :nudge-right="0"
            :return-value.sync="datum_iskopavanja"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field slot="activator" v-model="datum_iskopavanja" label="Iskrčen" readonly></v-text-field>
            <v-date-picker v-model="datum_iskopavanja" no-title scrollable :max="maxDate">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu_iskopavanja = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.menu_iskopavanja.save(datum_iskopavanja)">OK</v-btn>
            </v-date-picker>
          </v-menu> -->
          <v-menu
            ref="menu_iskopavanja"
            v-model="menu_iskopavanja"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="datum_iskopavanja"
              label="Iskrčen"
              readonly
              
                @blur="date = parseDate(datum_iskopavanja)"
            ></v-text-field>
            <v-date-picker v-model="date" no-title @input="menu_iskopavanja = false" :max="maxDate"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs10 pa-2>
          <v-text-field v-model="opis" label="Opis"></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled">Sačuvaj</v-btn>
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken"/>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "VineyardGrapeItem",
  components: {
      TokenComponent
    },
  data: () => ({
    valid: true,
    ID: 0,
    wt_items: [],
    select: "",
    opis: "",
    vineyard_items: [],
    vineyard_select: 0,
    velicina: 0,
    jm_select: 0,
    jm_items: [],
    datum_zasada: "",
    menu: "",
    menu_iskopavanja: "",
    datum_iskopavanja: null,
    date: null,
    date_zasada: null,
    vinarija: true,
      vinogradGl: "Vinograd",
      vinogradGl1: "Sorte u vinogradu",
  }),
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    }
  },
  watch: {
    date (val) {
      this.datum_iskopavanja = this.formatDate1(this.date)
    },
    date_zasada (val) {
      this.datum_zasada = this.formatDate1(this.date_zasada)
    },
    entry_date (val) {
      this.entry_dateFormatted = this.formatDate1(this.entry_date)
    }
  },
  methods: {
    formatDate1 (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    newSifarnik() {
      var complexObjectVineyard;



      if (this.vineyard_select.id == null)
        complexObjectVineyard = {
          id: this.vineyard_select
        };
      else
        complexObjectVineyard = {
          id: this.vineyard_select.id
        };

      var complexObjectGrapeVariety;

      if (this.select.id == null)
        complexObjectGrapeVariety = {
          id: this.select
        };
      else
        complexObjectGrapeVariety = {
          id: this.select.id
        };

      var complexObjectUnitOfMeasure = null;

      if (typeof this.jm_select !== "undefined")
        if (typeof this.jm_select.id !== "undefined")
          complexObjectUnitOfMeasure = {
            id: this.jm_select.id
          };
        else if (typeof this.jm_select !== "undefined")
          complexObjectUnitOfMeasure = {
            id: this.jm_select
          };

 

      if (complexObjectUnitOfMeasure !== null){
    if (typeof this.velicina !== "undefined")
        var complexObject = {
          vineyard: complexObjectVineyard,
          grapeVariety: complexObjectGrapeVariety,
          quantity: this.velicina,
          unitOfMeasure: complexObjectUnitOfMeasure,
          plantDate: this.date_zasada + "T00:00",
          destroyDate: this.date,
          description: this.opis
        };
      else
        var complexObject = {
          vineyard: complexObjectVineyard,
          grapeVariety: complexObjectGrapeVariety,
          quantity: 0,
          unitOfMeasure: complexObjectUnitOfMeasure,
          plantDate: this.date_zasada + "T00:00",
          destroyDate: this.date,
          description: this.opis
        };
      }
      else
        if (typeof this.velicina !== "undefined")
          var complexObject = {
            vineyard: complexObjectVineyard,
            grapeVariety: complexObjectGrapeVariety,
            quantity: this.velicina,
            plantDate: this.date_zasada + "T00:00",
            destroyDate: this.date,
            description: this.opis
          };
        else
            var complexObject = {
            vineyard: complexObjectVineyard,
            grapeVariety: complexObjectGrapeVariety,
            plantDate: this.date_zasada + "T00:00",
            destroyDate: this.date,
            description: this.opis
          };
      
      // console.log(JSON.stringify(complexObject));

      if (this.datum_iskopavanja < this.datum_zasada)
        alert(
          "Datum zasada mora biti manji ili jednak datumu iskopavanja vinograda."
        );
      else {
        this.$http
          .post(
            this.globalServiceLocation + this.globalPort + "/vineyard_grape_variety/create",
            complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
          )
          .then(response => {
            serverBus.$emit("refresh_vineyardgrape", this.ID);
            this.clear();
          })
          .catch(e => {
            // // console.log(e.response);

            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
          .post(
            this.globalServiceLocation + this.globalPort + "/vineyard_grape_variety/create",
            complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
          )
          .then(response => {
            serverBus.$emit("refresh_vineyardgrape", this.ID);
            this.clear();
          })
          .catch(e => {
            // // console.log(e.response);

            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
          });
      }
    },
    changeSifarnik() {
      if (this.datum_iskopavanja < this.datum_zasada)
        alert(
          "Datum zasada mora biti manji ili jednak datumu iskopavanja vinograda."
        );
      else {

      var complexObjectVineyard;

      if (this.vineyard_select.id == null)
        complexObjectVineyard = {
          id: this.vineyard_select
        };
      else
        complexObjectVineyard = {
          id: this.vineyard_select.id
        };

      var complexObjectGrapeVariety;

      if (this.select.id == null)
        complexObjectGrapeVariety = {
          id: this.select
        };
      else
        complexObjectGrapeVariety = {
          id: this.select.id
        };

      var complexObjectUnitOfMeasure = null;



      if (typeof this.jm_select !== "undefined")
        if (typeof this.jm_select.id !== "undefined")
          complexObjectUnitOfMeasure = {
            id: this.jm_select.id
          };
        else if (typeof this.jm_select !== "undefined")
          complexObjectUnitOfMeasure = {
            id: this.jm_select
          };

if (complexObjectUnitOfMeasure !== null){

if (typeof this.velicina !== "undefined")
      var complexObject = {
        id: this.ID,
        vineyard: complexObjectVineyard,
        grapeVariety: complexObjectGrapeVariety,
        quantity: this.velicina,
        unitOfMeasure: complexObjectUnitOfMeasure,
        plantDate: this.date_zasada + "T00:00",
        destroyDate: this.date,
        description: this.opis
      };
  else
    var complexObject = {
        id: this.ID,
        vineyard: complexObjectVineyard,
        grapeVariety: complexObjectGrapeVariety,
        quantity: 0,
        unitOfMeasure: complexObjectUnitOfMeasure,
        plantDate: this.date_zasada + "T00:00",
        destroyDate: this.date,
        description: this.opis
      };
}
else
      if (typeof this.velicina !== "undefined")
          var complexObject = {
            id: this.ID,
        vineyard: complexObjectVineyard,
            grapeVariety: complexObjectGrapeVariety,
            quantity: this.velicina,
            plantDate: this.date_zasada + "T00:00",
            destroyDate: this.date,
            description: this.opis
          };
        else
            var complexObject = {
            id: this.ID,
        vineyard: complexObjectVineyard,
            grapeVariety: complexObjectGrapeVariety,
            plantDate: this.date_zasada + "T00:00",
            destroyDate: this.date,
            description: this.opis
          };

        this.$http
          .put(
            //this.globalServiceLocation + this.globalPort + "/vineyard_grape_variety/update/" + this.ID,
            this.globalServiceLocation + this.globalPort + "/vineyard_grape_variety/update",
            complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
          )
          .then(response => {
            serverBus.$emit("refresh_vineyardgrape", this.ID);
            this.clear();
          })
          .catch(e => {
            // // console.log(e.response);

            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
          .put(
            //this.globalServiceLocation + this.globalPort + "/vineyard_grape_variety/update/" + this.ID,
            this.globalServiceLocation + this.globalPort + "/vineyard_grape_variety/update",
            complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
          )
          .then(response => {
            serverBus.$emit("refresh_vineyardgrape", this.ID);
            this.clear();
          })
          .catch(e => {
            // // console.log(e.response);

            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
          });
      }
    },
    getAllJediniceMere() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/unit_of_measure/grape_variety_in_vineyard", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // console.log(response.data);

          this.jm_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/unit_of_measure/grape_variety_in_vineyard", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // console.log(response.data);

          this.jm_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllGrapeVariety() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/grape_variety/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/grape_variety/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllVineyard() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/vineyard/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.vineyard_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/vineyard/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.vineyard_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }

        
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;
    }
  },
  mounted() {
    this.clear();
    var d = new Date();
    this.godina = d.getFullYear();

    this.getAllGrapeVariety();
    this.getAllVineyard();
    this.getAllJediniceMere();

    serverBus.$on("applied_vineyardgrape", item => {
      //// // console.log(item);



      this.ID = item.id;
      this.vineyard_select = item.vineyard.id;
      this.select = item.grapeVariety.id;

      

      // if (item.unitOfMeasure !== null)
      //   this.jm_select = item.unitOfMeasure.id;

      this.velicina = item.quantity;
      this.date_zasada = item.plantDate;
      this.date = item.destroyDate;
      this.opis = item.description;
    });
  },
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if(!this.vinarija){
      this.vinogradGl = "Zasad";
      this.vinogradGl1 = "Sorte u zasadu";
    }
      
  }
};
</script>
    
<style lang="scss" scoped>
.wineItemComponentForm {
  max-width: 430px;
}
.Description textarea {
  height: 40px;
}
</style>
